import { render } from "./MainSearchResultView.vue?vue&type=template&id=7a5840f8"
import script from "./MainSearchResultView.vue?vue&type=script&lang=js"
export * from "./MainSearchResultView.vue?vue&type=script&lang=js"

import "./MainSearchResultView.vue?vue&type=style&index=0&id=7a5840f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__